module.exports = __webpack_public_path__ + "static/img/blog-details-with-leftsidebar.9eb650d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blog-details-with-leftsidebar.jpg
// module id = ZiR9
// module chunks = 36